(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return

    observer.unobserve(productRecommendationsSection)

    const url = productRecommendationsSection.dataset.url

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text
        const recommendations = html.querySelector('.product-recommendations')

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  const productRecommendationsSection = document.querySelector(
    '.product-recommendations'
  )
  const observer = new IntersectionObserver(handleIntersection, {
    rootMargin: '0px 0px 200px 0px',
  })

  observer.observe(productRecommendationsSection)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-section-25"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function($) {
  $('.image-text-carousel').slick({
    dots: true,
    infinite: true,
    nav: true,
    autoplay: false,
    speed: 300,
    slidesToShow: 3,  // Show 1 item on mobile by default
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,  // Tablet and desktop breakpoint
        settings: {
          slidesToShow: 3,  // 3 items at a time on desktop and tablet
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,  // Tablet breakpoint
        settings: {
          slidesToShow: 3,  // 3 items at a time on tablets
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 480,  // Mobile breakpoint
        settings: {
          slidesToShow: 1,  // 1 item at a time on mobile
          slidesToScroll: 1
        }
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();
})();
